export default "__VITE_ASSET__CR8y4xBo__"